import '../styles/global.css';
import '@enonic/react-components/utils/initPublicPath'
import {AppProps} from '/types/AppProps';
import type {MetaData} from '@enonic/react-components';
import {BaseComponent} from '@enonic/react-components';
import * as React from 'react';
import {componentRegistry} from '../componentRegistry';
import {Breadcrumb, Header, Footer} from '../components/primitives';
import type {BreadcrumbItem, FooterData, MenuData} from '../components/primitives';

const App: React.FC<AppProps> = ({component, data, common, meta}) => {
    const compMeta: MetaData = {...meta as MetaData, componentRegistry};

    const componentType = (component as unknown as Record<string, unknown>)?.type as string | undefined
    const isPartOrLayout = componentType === 'part' || componentType === 'layout'

    if (isPartOrLayout) {
        return <BaseComponent component={component} data={data} common={common} meta={compMeta}/>
    }

    const pageData = data as Record<string, unknown> | undefined
    const hasHero = pageData?.hasHero === true
    const heroOverlay = pageData?.heroOverlay === true
    const pageBackground = pageData?.pageBackground as string | undefined
    const commonData = common as Record<string, unknown> | undefined
    const breadcrumbs = commonData?.breadcrumbs as BreadcrumbItem[] | undefined
    const logoUrl = commonData?.logoUrl as string | undefined
    const logoLightUrl = commonData?.logoLightUrl as string | undefined
    const footerLogoUrl = commonData?.footerLogoUrl as string | undefined
    const footerData = commonData?.footer as FooterData | undefined
    const menuData = commonData?.menu as MenuData | undefined

    const pageBgClass = pageBackground === 'blue'
        ? 'bg-blue-100'
        : pageBackground === 'peach'
            ? 'bg-peach-100'
            : ''

    return (
        <div className={pageBgClass}>
            <a
                href="#main"
                className="sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:top-4 focus-visible:left-4 focus-visible:z-[100] focus-visible:rounded focus-visible:bg-white focus-visible:px-4 focus-visible:py-2 focus-visible:text-base focus-visible:text-black focus-visible:outline-1 focus-visible:outline-slate-300"
            >
                Hopp til hovedinnhold
            </a>
            {logoUrl && (
                <Header
                    logoUrl={heroOverlay && logoLightUrl ? logoLightUrl : logoUrl}
                    menu={menuData}
                    heroOverlay={heroOverlay}
                />
            )}
            {!hasHero && breadcrumbs && breadcrumbs.length > 1 && (
                <Breadcrumb items={breadcrumbs} />
            )}
            <BaseComponent component={component} data={data} common={common} meta={compMeta}/>
            {footerLogoUrl && footerData && (
                <Footer
                    logoUrl={footerLogoUrl}
                    footer={footerData}
                    meta={compMeta}
                    common={common}
                    component={component}
                />
            )}
        </div>
    );
}

App.displayName = 'App';

export default App;

